import React, { memo } from 'react'
import { useTranslation } from 'react-i18next'
import { useFilterBySearch } from 'astra-core/containers/EventsProvider/hooks/list-filters'

import { SearchEventsInput } from 'widgets/search-events-input'
import { TimePeriodFilter } from 'features/events-filters/ui/TimePeriodFilter'
import {
  CALENDAR_EVENTS_LIST_KEY,
  CALENDAR_PERIOD_OPTIONS
} from 'pages/calendar/model/constants'

import { StyledFilters, StyledInputWrapper } from './Filters.styled'

export const Filters = memo(() => {
  const [t] = useTranslation()
  const { value, onChangeSearch } = useFilterBySearch(CALENDAR_EVENTS_LIST_KEY)

  const periodOptions = CALENDAR_PERIOD_OPTIONS(t)

  return (
    <StyledFilters>
      <TimePeriodFilter
        listKey={CALENDAR_EVENTS_LIST_KEY}
        periodOptions={periodOptions}
      />
      <StyledInputWrapper>
        <SearchEventsInput
          initialValue={value}
          key={CALENDAR_EVENTS_LIST_KEY}
          onChange={onChangeSearch}
        />
      </StyledInputWrapper>
    </StyledFilters>
  )
})
